// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__jsNfz","logo":"Footer_logo__Xx619","submitBtn":"Footer_submitBtn__lRPyM","legal":"Footer_legal__IictF"};